var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserAgreement"},[_c('div',{staticClass:"UserAgreement_1"},[_c('div',{staticClass:"UserAgreement_1_1"},[_vm._v("《协议条款》")]),_c('div',{},[_vm._v(" "+_vm._s(_vm.detail)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }